import React, { useCallback, useEffect, useState } from 'react';
import Menu from '../Menu/Menu';
import '../../styles/core.css';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useNavigate, useParams } from 'react-router-dom';

function Apilogs() {
  const [logs, setLogs] = useState('');

  useEffect(() => {
    fetch('https://ser.eyas-focus.o-r.kr/api/admin/logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then(({ status, data }) => {
        if (status) {
          setLogs(data)
        } else {
          alert('데이터 저장에 실패했습니다.');
        }
      })
      .catch((err) => {
        console.error('Error saving data:', err);
        alert('서버 오류가 발생했습니다.');
      });
  }, []);



  return (
    <Menu>
      <Box sx={{
        float: 'left',
        width: 'calc(100% - 260px)',
        minWidth: '98%',
        marginTop: '30px',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        padding: '10px 2px',
      }}>
        <div>
          <h1>Audit Log Viewer</h1>
          {logs ? (
            logs.split('\n').map((log, index) => (
              <p key={index} style={{ margin: '0', whiteSpace: 'pre-wrap' }}>{log}</p>
            ))
          ) : (
            <pre>에러</pre>
          )}
        </div>
      </Box>
    </Menu>

  );
}

export default Apilogs;
